import styled from "styled-components"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import MetaData from "@/common/components/MetaData"
import Sticky from "react-stickynode"
import dynamic from "next/dynamic"
import { UseCase, UseCaseLayout } from "@/common/components/UseCase"

import lineGroupG from "@/common/assets/image/walletAsAService/showCase/premise/lineGroupG.svg"
import TAGLOGO from "@/common/assets/image/walletAsAService/showCase/TAGLOGO.webp"
import TAGHero from "@/common/assets/image/walletAsAService/showCase/hero&banner/TAG Hero.webp"
import TAG1_P from "@/common/assets/image/walletAsAService/showCase/premise/TAG1.svg"
import TAG2_P from "@/common/assets/image/walletAsAService/showCase/premise/TAG2.svg"
import TAG3_P from "@/common/assets/image/walletAsAService/showCase/premise/TAG3.svg"
import TAG1_S from "@/common/assets/image/walletAsAService/showCase/solutions/TAG1.webp"
import TAG2_S from "@/common/assets/image/walletAsAService/showCase/solutions/TAG2.webp"
import TAG3_S from "@/common/assets/image/walletAsAService/showCase/solutions/TAG3.webp"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))
const TAGUseCasePage = () => {
  const { t } = useTranslation(["useCaseTag"])
  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/use-case/tag-wallet"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/use-case/tag-wallet"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/use-case/tag-wallet"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/use-case/tag-wallet"
          }
        ]}
      />
      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <LayoutWrapper>
        <UseCaseLayout
          content={
            <UseCase
              data={{
                hero: {
                  title1: t("hero.title1"),
                  title2: t("hero.title2"),
                  title3: t("hero.title3"),
                  desc: t("hero.desc"),
                  icon: TAGLOGO,
                  btns: "",
                  hero: TAGHero
                },
                showCaseCounter: [
                  {
                    content: t("counter.1.content"),
                    desc: t("counter.1.desc")
                  },
                  {
                    content: t("counter.2.content"),
                    desc: t("counter.2.desc")
                  },
                  {
                    content: t("counter.3.content"),
                    desc: t("counter.3.desc")
                  }
                ],
                theySays: {
                  content1: t("theySays.content1"),
                  content2: t("theySays.content2")
                },
                premise: {
                  title2: t("premise.title2"),
                  content1: [
                    t("premise.content1.1"),
                    t("premise.content1.2"),
                    t("premise.content1.3"),
                    t("premise.content1.4")
                  ],
                  content2: [
                    { Icon: TAG1_P, content: t("premise.content2.1") },
                    { Icon: TAG2_P, content: t("premise.content2.2") },
                    { Icon: TAG3_P, content: t("premise.content2.3") }
                  ],
                  result: t("premise.result"),
                  lineGroup: lineGroupG
                },
                solution: {
                  title: t("solution.title"),
                  QA: [
                    {
                      q: t("solution.1.q"),
                      a: t("solution.1.a"),
                      img: TAG1_S
                    },
                    {
                      a: t("solution.2.a"),
                      q: t("solution.2.q"),
                      img: TAG2_S
                    },
                    {
                      q: t("solution.3.q"),
                      a: t("solution.3.a"),
                      img: TAG3_S
                    }
                  ]
                },

                color: {
                  primary: "#57EE88",
                  secondary: "#4C9595"
                }
              }}
              next="kryptogo-wallet"
            />
          }
        />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "useCaseCommon",
      "contactUs",
      "useCaseTag"
    ]))
  }
})

export default TAGUseCasePage

const LayoutWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
`
